var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:{'unstyled-button': true, 'like-link': _vm.link, 'no-underline': _vm.noUnderline},attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }